export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{ translations.Invoices }}
	</div>
	{% if customer.CompanyErpId <= 0 -%}
	<div class="no-data">{{ translations.AccessDenied }}</div>
	{% else %}
	<div class="eshop__table-container products erp-data-js" style="display: none" data-template="partials/customer-profile/invoices/invoice-details.html">
		<table>
			<colgroup>
				<col style="width:100px">
				<col style="width:150px">
				<col style="width:150px">
				<col style="width:150px">
				<col style="width:150px">
			</colgroup>
			<div class="erp-orders-tab">
				<label for="dateTo">{{ translations.InvoicesFromLast3MonthsTo }}:</label>
				<input id="dateTo" class="form__input-value get-erp-data-js" type="date" name="dateTo" >
			</div>
			<thead>
				<tr>
					<th class="id">{{ translations.Number | Capitalize }}</th>
					<th>{{ translations.BuyDate }}</th>
					<th>{{ translations.PaymentDueDate }}</th>
					<th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
					<th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
					<th class="to-pay-column-js hidden-js">{{ translations.ToPay }}</th>
				</tr>
			</thead>
			<div class="table-js" data-sp="CDN.eshop_GetInvoices">
				<tbody>
					<tr tabindex="0" class="row can-hover load-erp-invoice-details-js parent-container-reload-js" data-url="{{ page.Url }}?&deeper-lvl=true&erp-data=true&invoice-erp=true" rv-each-o="List">
						<td class="id" rv-data-id="o.Id">{ o.ERPInvoiceNumber }</td>
						<td>{ o.Date | date }</td>
						<td rv-class-error="o.DaysAfterExists">{ o.DueDate | date }							
							<span class="info-icon" rv-if="o.DaysAfterExists">
								<svg height="16" width="16">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#info-circle-{{settings.iconStyle}}"></use>
								</svg> 
							</span>
							<span class="hover-text" rv-if="o.DaysAfterExists">{ o.DaysAfterDueDate } {{ translations.DaysAfterDeadline | Downcase }}</span>
						</td>
						<td>{ o.SubtotalValue | price } { o.Currency }</td>
						<td>{ o.TotalValue | price } { o.Currency }</td>
						<td class="payment to-pay-column-js hidden-js">
							<span rv-if="o.ToPayExists">{ o.ToPay | price } { o.Currency }</span>
							<span rv-if="o.ToReturnExists">-{ o.ToReturn | price } { o.Currency }</span>
						</td>
					</tr>
				</tbody>
			</div>
		</table>
		<div class="no-data">{{ translations.NoInvoices }}</div>
		{% include 'partials/customer-profile/pagination.html' -%}
	</div>
	<div class="loader-js loader big"></div>
	{% endif -%}
</div>
`